import { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';

export const InitialDataContext = createContext({});
export function useInitialData() {
  const value = useContext(InitialDataContext);
  const { pathname, search } = useLocation();
  return value.path === pathname && !search ? value : {};
}
